import { DotLegalAlert, DotLegalHeader, DotLegalSelect } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../localization/useTranslation";
import { Box } from "@mui/material";
import { AiSpendingWarning, isAiSpendingExhausted } from "../../../aiAdministration/AiAdministration.types";
import AiSpendingWarningAlert from "../../../aiAdministration/AiSpendingWarningAlert";

interface BestPracticeCheckDialogContentProps {
    selectedTemplateId: string | null;
    setSelectedTemplateId: (value: string | null) => void;
    templateOptions: Array<{ id: string; name: string }> | undefined;
    isComparing: boolean;
    isLoadingTemplates?: boolean;
    spendingWarning?: AiSpendingWarning;
}

function BestPracticeCheckDialogContent(props: BestPracticeCheckDialogContentProps) {
    const { translateString } = useTranslation();
    const isAiExhausted = isAiSpendingExhausted(props.spendingWarning);

    return (
        <>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
                <DotLegalHeader headerStyle={"small"} fontWeight={400}>
                    {translateString("aiQualityAssuranceDialogInfoText")}
                </DotLegalHeader>
            </Box>

            <DotLegalSelect
                options={props.templateOptions}
                selectedItem={props.selectedTemplateId}
                onChange={(value) => props.setSelectedTemplateId(value)}
                label={translateString("bestPracticeDocumentTemplates")}
                placeholder={translateString("bestPracticeDocumentTemplates")}
                noOptionsLabel={translateString("noOptions")}
                isLoading={props.isLoadingTemplates}
                disabled={isAiExhausted}
            />

            {props.isComparing && (
                <Box sx={{ marginTop: 2 }}>
                    <DotLegalAlert
                        severity="info"
                        warningHeader={translateString("aiQualityAssuranceAnalyzingDocument")}
                        warningText={translateString("extractingContractInfo")}
                    />
                </Box>
            )}

            <AiSpendingWarningAlert warning={props.spendingWarning} />
        </>
    );
}

export default BestPracticeCheckDialogContent;
